var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle207(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "323.4197649381351 589.7030540309117 22.372118695623044 25.401217596351444",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M341.79,605.22c-.1,4.86-4.72,7.4-8.95,4.92-3.62-2.12-6.13-7.82-5.24-11.91.88-4.11,5.45-5.84,8.99-3.42,2.8,1.91,5.28,6.86,5.2,10.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle207);
export default __webpack_public_path__ + "static/media/twinkle-2-07.bc39df9c6c494273f9bb859aa8544b6a.svg";
export { ForwardRef as ReactComponent };